import { put, select, takeLatest } from 'redux-saga/effects'
import { IRootState } from '../../../store'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { getRootStateSelector } from '../selectors/getRootState.selector'
import { RulesService } from '../services/rules.service'
import { RulesConstants } from '../store/rules.constants'

export function* runRules() {
  try {
    const serviceId: string = yield select(getServiceIdSelector)
    const data: IRootState = yield select(getRootStateSelector)

    RulesService.runRulesForService(serviceId, data, true)
  } catch (e) {
    yield put(throwPcrException(`runRules() error: ${e}`))
  }
}

export function* runRulesSaga() {
  yield takeLatest([RulesConstants.DO_RUN_RULES], runRules)
}
